import { RES_PER_PAGE, API_URL, KEY } from './config.js';
import { async } from 'regenerator-runtime';
import { getJSON , sendJSON } from './helpers.js';


export const state = {
    recipe: {},
    search: {
        query: '',
        results: [],
        resultsPerPage: RES_PER_PAGE,
        page: 1,
    },
    bookmarks: [],
}

export const loadRecipe = async function (id) {
    try {
    const data = await getJSON(`${API_URL}${id}?key=${KEY}`);

    const { recipe } = data.data;
    state.recipe = {
        id: recipe.id,
        title: recipe.title,
        publisher: recipe.publisher,
        sourceUrl: recipe.source_url,
        image: recipe.image_url,
        servings: recipe.servings,
        cookingTime: recipe.cooking_time,
        ingredients: recipe.ingredients,
        ...(recipe.key && { key: recipe.key }),
    };

    if (state.bookmarks.some(bookmark => bookmark.id === id)) {
        state.recipe.bookmarked = true;
    } else state.recipe.bookmarked = false;
    } catch (err) {
        throw err;
    }
}

export const loadSearchResults = async function (query) {
    try {
        state.search.query = query;

        const data = await getJSON(`${API_URL}?search=${query}&key=${KEY}`);
        state.search.results = data.data.recipes.map(rec => {
            return {
                id: rec.id,
                title: rec.title,
                publisher: rec.publisher,
                image: rec.image_url,
                ...(rec.key && { key: rec.key }),
            };
        });
        state.search.page = 1;
    } catch (err) {
        throw err;
    }
}


export const getSearchResultsPage = function (page = state.search.page) {
    state.search.page = page;
    const start = (page - 1) * RES_PER_PAGE;
    const end = page * RES_PER_PAGE;
    return state.search.results.slice(start, end);
}

export const updateServings = function (newServings) {
    state.recipe.ingredients.forEach(ing => {
        ing.quantity = ing.quantity * newServings / state.recipe.servings;
    });
    state.recipe.servings = newServings;
}

const persistBookmarks = function () {
    localStorage.setItem('bookmarks', JSON.stringify(state.bookmarks));
}



export const addBookmark = function (recipe) {
    state.bookmarks.push(recipe);
    if (recipe.id === state.recipe.id) state.recipe.bookmarked = true;
    persistBookmarks();
}


export const deleteBookmark = function (id) {
    const index = state.bookmarks.findIndex(el => el.id === id);
    state.bookmarks.splice(index, 1);
    if (id === state.recipe.id) state.recipe.bookmarked = false;
    persistBookmarks();

}

const init = function () {
    const storage = localStorage.getItem('bookmarks');
    if (storage) state.bookmarks = JSON.parse(storage);
}

init();

const clearBookmarks = function () {
    localStorage.clear('bookmarks');
}

// clearBookmarks();

export const uploadRecipe = async function (newRecipe) {
    try {
        const ingredients = Object.entries(newRecipe)
            .filter(entry => entry[0].startsWith('ingredient') && entry[1] !== '')
            .map(ing => {
                const ingArr = ing[1].split(',').map(el => el.trim());
                if (ingArr.length !== 3) throw new Error('Wrong ingredient format! Please use the correct format :)');
                const [quantity, unit, description] = ingArr;
                return { quantity: quantity ? +quantity : null, unit, description };
            });
            const recipe = {
                title: newRecipe.title,
                source_url: newRecipe.sourceUrl,
                image_url: newRecipe.image,
                publisher: newRecipe.publisher,
                cooking_time: +newRecipe.cookingTime,
                servings: +newRecipe.servings,
                ingredients,
            };
            const data = await sendJSON(`${API_URL}?key=${KEY}`, recipe);
            const { recipe: createdRecipe } = data.data;
            state.recipe = {
                id: createdRecipe.id,
                title: createdRecipe.title,
                publisher: createdRecipe.publisher,
                sourceUrl: createdRecipe.source_url,
                image: createdRecipe.image_url,
                servings: createdRecipe.servings,
                cookingTime: createdRecipe.cooking_time,
                ingredients: createdRecipe.ingredients,
                ...(createdRecipe.key && { key: createdRecipe.key }),
            };
            addBookmark(state.recipe);
    } catch (err) {
        throw err;
    }
}